import styled from 'styled-components';
import AddImageIcon from 'assets/icons/add-image.svg?react';
import ImageIcon from 'assets/icons/image.svg?react';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 5px;
  overflow: hidden;
`;

export const ImageContainer = styled.div`
  border: solid 2px ${({ theme }) => theme.colors.freshGreen};
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AddImage = styled(AddImageIcon)`
  color: ${({ theme }) => theme.colors.freshGreen};
  height: 30px;
  width: 30px;
`;

export const Image = styled(ImageIcon)`
  color: ${({ theme }) => theme.colors.freshGreen};
  height: 30px;
  width: 30px;
`;
